import { UserService } from '../services/user.service';

const initialState = () => ({
  status: {
    error: null,
    pending: true,
    saving: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  updatePassword({ commit }, { passwords, userId }) {
    commit('SAVE_PASSWORD');
    return UserService.updatePassword(passwords, userId)
      .then((data) => {
        commit('SUCCESS');

        return data;
      })
      .catch((error) => {
        commit('ERROR', error);

        throw error;
      });
  },
};

const mutations = {
  SAVE_PASSWORD(state) {
    state.status = {
      error: null,
      pending: false,
      saving: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      saving: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      saving: false,
      rejected: true,
      error: error,
    };
  },
};
const getters = {
  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  saving: (state) => state.status.saving,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const changePassword = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
